module.exports = __webpack_public_path__ + "img/flight-schedule-not-found.46741a22.svg";